import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import mitt from 'mitt';
import Toaster from '@meforma/vue-toaster';
import VueApexCharts from 'vue3-apexcharts';
import UtilityService from '@/services/UtilityService';

//FONTELLO ICONS
import './assets/fontello/animation.css';
import './assets/fontello/fontello.css';
import './assets/fontello/fontello-codes.css';
import './assets/fontello/fontello-embedded.css';
import './assets/fontello/fontello-ie7.css';
import './assets/fontello/fontello-ie7-codes.css';

import './assets/styles/index.scss';

//APP COMPONENTS
import AppSection from '@/components/app/AppSection';
import AppTitle from '@/components/app/AppTitle';
import AppButton from '@/components/app/AppButton';
import AppInput from '@/components/app/AppInput';
import AppSelect from '@/components/app/AppSelect';
import NotificationService from '@/services/NotificationService';
import AppBackButton from '@/components/app/AppBackButton';
import AppLine from '@/components/app/AppLine';
import AppHeaderTeleport from '@/components/app/AppHeaderTeleport';
import AppCheckbox from '@/components/app/AppCheckbox';
import AppTextArea from '@/components/app/AppTextArea';
import AppIcon from '@/components/app/AppIcon';

import translationEN from './assets/locales/en/translation.json';
import translationSQ from './assets/locales/sq/translation.json';
import translationIT from './assets/locales/it/translation.json';
// import './assets/locales/it/translation.json';

const emitter = mitt();

let app = createApp(App)
	.use(store)
	.use(Toaster)
	.use(VueApexCharts)
	.use(router)
	.use(I18NextVue, { i18next });

app.component('app-section', AppSection);
app.component('app-title', AppTitle);
app.component('app-button', AppButton);
app.component('app-input', AppInput);
app.component('app-select', AppSelect);
app.component('app-back-button', AppBackButton);
app.component('app-line', AppLine);
app.component('app-header-teleport', AppHeaderTeleport);
app.component('app-checkbox', AppCheckbox);
app.component('app-text-area', AppTextArea);
app.component('app-icon', AppIcon);

// app.config.productionTip = false;
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.$notificationService = new NotificationService(app);
app.config.globalProperties.$filters = UtilityService.filters;

//firebase
import firebase from 'firebase/app';
import 'firebase/messaging';

i18next
	.use(LanguageDetector)
	.use(HttpApi)
	.init({
		debug: false,
		fallbackLng: 'en',
		backend: {
			loadPath: '/assets/locales/en/translation.json',
		},
		resources: {
			en: {
				translation: translationEN,
			},
			sq: {
				translation: translationSQ,
			},
			it: {
				translation: translationIT,
			},
		},
	});

// Initialize Firebase
firebase.initializeApp({
	apiKey: 'AIzaSyAvQ6mDu9jhQbisJlx4an8vLhAYGPr8p3U',
	authDomain: 'baboon-1125.firebaseapp.com',
	databaseURL: 'https://baboon-1125.firebaseio.com',
	projectId: 'baboon-1125',
	storageBucket: 'baboon-1125.appspot.com',
	messagingSenderId: '777937716876',
	appId: '1:777937716876:web:06a4ebfdf0103d8427dda9',
	measurementId: 'G-N9H7EYHWTS',
});

navigator.serviceWorker
	.register('firebase-messaging-sw.js', { scope: 'firebase-cloud-messaging-push-scope' })
	.then((registration) => {
		const messaging = firebase.messaging();
		messaging.useServiceWorker(registration);
		registration.addEventListener('message', (event) => {
			console.log(event);
		});
	})
	.catch((err) => {
		console.log(err);
	});

router.isReady().then(() => {
	app.mount('#app');
});
